// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GoodsList-module--Wrapper--2LxzD"};